import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

// Grouped bar chart used by both "Book Wise Distribution" and
// "Year Wise Growth" dashboard widgets.
export default function TspBarChart({
  data,
  xKey,
  series,
  height = 220,
  margin = { top: 10, right: 12, left: -12, bottom: 0 },
  interval,
  angle,
  textAnchor,
  xAxisHeight,
  fontSize = 11,
  barSize = 14,
  tickFormatter,
}) {
  const renderCustomTick = (props) => {
    const { x, y, payload } = props;
    const rawText = payload ? payload.value : "";
    const text = tickFormatter ? tickFormatter(rawText) : rawText;
    if (angle) {
      return (
        <g transform={`translate(${x},${y})`}>
          <text
            x={0}
            y={0}
            dy={8}
            textAnchor={textAnchor || "end"}
            fill="#9AA3B2"
            fontSize={fontSize}
            transform={`rotate(${angle})`}
          >
            {text}
          </text>
        </g>
      );
    }
    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={0}
          y={0}
          dy={10}
          textAnchor="middle"
          fill="#9AA3B2"
          fontSize={fontSize}
        >
          {text}
        </text>
      </g>
    );
  };

  return (
    <div className="tsp-bar-chart" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={margin}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#EEF1F6" />
          <XAxis
            dataKey={xKey}
            tickLine={false}
            axisLine={false}
            interval={interval !== undefined ? interval : 0}
            height={xAxisHeight || (angle ? 55 : 30)}
            tick={renderCustomTick}
          />
          <YAxis tickLine={false} axisLine={false} fontSize={10} stroke="#9AA3B2" width={32} />
          <Tooltip />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          {series.map((s) => (
            <Bar key={s.key} dataKey={s.key} name={s.name} fill={s.color} radius={[4, 4, 0, 0]} barSize={barSize} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
